import { BooleanParam, NumberParam, StringParam } from 'use-query-params';

export const CLIENT_QUOTE_EDITOR_PAGE_PARAMS = {
  startDate: StringParam,
  endDate: StringParam,
  workingDays: StringParam,
  usdToGbpRate: NumberParam,
  isD2NA: BooleanParam,
} as const;
